import styled from '@emotion/styled';
export const InputsContainer = styled.form`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const SwitchWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;

    label {
        margin-bottom: 0;
        display: inline-block;
    }
`;
